




































































import { Component, Vue, Prop, Provide, Watch } from 'vue-property-decorator'
import PaperHead from './PaperHead.vue'
import QuestionType from './QuestionType.vue'
import QRender from '@/components/qrender/QRender.vue'
import QuestionBox from './QuestionBox.vue'
import { numToChinese } from './../model/numberToChinese'
import {
  questionDetail,
  removeUestionFromCart,
  updateQuestionCart,
  listDetail,
  similarSearch,
  switchQuestion
} from './../model/api'
import { sa } from '@/utils/sa'

@Component({
  components: { PaperHead, QuestionType, QRender, QuestionBox }
})
export default class Paper extends Vue {
  public data: any = []
  private modal: boolean = false
  private loading: boolean = false
  private spinning: boolean = false
  public showAnalysisQuestionIds: any = []
  private samilerQuestions: any = []
  private currentIndex: number = 0
  private oldQuestionId: string = ''
  private get currentQuestion() {
    return this.samilerQuestions.length > 0 ? this.samilerQuestions[this.currentIndex] : {}
  }
  private get cartInfo() {
    return this.$store.state.question.cart
  }
  private get subjectId() {
    return this.$store.state.subject.value
  }
  private get userInfo() {
    return this.$store.state.user_info
  }
  @Watch('cartInfo', { deep: true })
  onCartChange(val) {
    if (val && val.question_ids && val.question_ids.length === 0) {
      location.href = '/search'
    }
    this.getDetail()
  }
  // mounted
  public mounted() {
    if (this.cartInfo && this.cartInfo.question_ids && this.cartInfo.question_ids.length === 0) {
      location.href = '/search'
    }
    this.getDetail()
  }
  public handleData(data) {
    data.forEach((element) => {
      element.sequence.forEach((n) => {
        n.inShoppingCart = true
        if (this.showAnalysisQuestionIds.indexOf(n.id) > -1) {
          n.showAnalysis = true
        } else {
          n.showAnalysis = false
        }
      })
    })
    this.data = data
  }
  public async getDetail() {
    let data = await listDetail({
      subject_id: this.subjectId
    })
    if (data.success) {
      this.handleData(data.msg.classification)
      // console.log(this.data)
    } else {
      this.data = []
      if (data.error === '请登录') {
        location.href = '/search'
      }
    }
  }
  public async cartDelete(id: number | string) {
    let data = await removeUestionFromCart({
      question_id: id,
      subject_id: this.subjectId
    })
    if (data.success) {
      // 更新购题篮
      this.$store.commit('SET_CART', data.msg)
      this.getDetail()
    }
  }
  public getPOsition(index, data) {
    if (data.length > 1) {
      if (index === data.length - 1) {
        return 'last'
      } else if (index === 0) {
        return 'first'
      } else {
        return 'mid'
      }
    } else {
      return ''
    }
  }
  public async addToCart(val) {
    this.cartDelete(val.id)
    //
    setTimeout(() => {
      sa.track('ContentRepository_question_Other', {
        screenType: '预览页面',
        buttonName: '移出试题篮'
      })
    }, 50)
  }
  public async setCart(data) {
    let params: any = {
      question_cart: data,
      subject_id: this.subjectId
    }
    let res = await updateQuestionCart(params)
    if (res.success) {
      this.$store.commit('SET_CART', res.msg)
    }
  }
  public async updateCart(data) {
    let params: any = {
      question_cart: {
        question_ids: data
      },
      subject_id: this.subjectId
    }
    let { msg } = await updateQuestionCart(params)
    this.$store.commit('SET_CART', msg)
  }
  public swapItems(arr, index1, index2) {
    arr[index1] = arr.splice(index2, 1, arr[index1])[0]
    return arr
  }
  public move(dir, key, val, idx) {
    let tempCart = JSON.parse(JSON.stringify(this.cartInfo))
    let arr = this.swapItems(val, idx, idx - dir)
    let temp: any = []
    for (let n of arr) {
      temp = [...temp, n.id]
    }
    let atom = tempCart.classification.find((itm) => {
      return ~~itm.type_id === ~~key
    })
    atom.sequence = temp
    this.setCart(tempCart)
  }
  public handleNumber(idx, questons, index, classification) {
    let count = 0
    if (index === 0) {
      return idx
    } else {
      for (let i = 0; i < index; i++) {
        count += classification[i].sequence.length
      }
      return count + idx
    }
  }
  public handleCount(val) {
    return numToChinese(val)
  }
  public openAnalysis(itm) {
    itm.showAnalysis = !itm.showAnalysis
    if (itm.showAnalysis) {
      this.showAnalysisQuestionIds = [...new Set([...this.showAnalysisQuestionIds, itm.id])]
    } else {
      let idx = this.showAnalysisQuestionIds.indexOf(itm.id)
      if (idx > -1) {
        this.showAnalysisQuestionIds.splice(idx, 1)
      }
    }
    setTimeout(() => {
      sa.track('ContentRepository_question_Other', {
        screenType: '预览页面',
        buttonName: '显示解析'
      })
    }, 50)
    // console.log(this.showAnalysisQuestionIds)
  }

  public async findSamilerQuestions(id) {
    this.spinning = true

    let that = this
    let param = {
      question_id: id
    }
    let data = await similarSearch(param)

    if (data.success) {
      if (!data.data.questions.length) {
        this.$warning({
          title: '暂无相似题',
          content: '我们正在努力制作，敬请期待',
          okText: '知道了'
        })
        return
      }
      this.modal = true
      data.data.questions.forEach((q) => {
        q.showAnalysis = true
      })
      this.samilerQuestions = data.data.questions
    } else {
      this.$message.warning(data.error)
    }
    this.spinning = false
  }

  public clickChange(question) {
    this.oldQuestionId = question.id
    this.findSamilerQuestions(this.oldQuestionId)
    setTimeout(() => {
      sa.track('ContentRepository_question_Other', {
        screenType: '预览页面',
        buttonName: '换一题'
      })
    }, 50)
  }

  public async handleOk() {
    let params = {
      old_question_id: this.oldQuestionId,
      new_question_id: this.currentQuestion.id,
      subject_id: this.subjectId
    }
    //
    setTimeout(() => {
      sa.track('ContentRepository_question_Other', {
        screenType: '预览页面',
        buttonName: '确定换题'
      })
    }, 50)
    let data = await switchQuestion(params)
    // console.log(data)
    // 换题成功后同步购物车
    if (data.success) {
      this.$store.commit('SET_CART', data.msg)
      this.handleCancel()
    } else {
      this.$message.warning('换题失败')
    }
  }

  public handleCancel() {
    let that = this
    // 重置
    this.modal = false
    setTimeout(() => {
      this.samilerQuestions = []
      this.currentIndex = 0
      this.oldQuestionId = ''
    }, 200)
  }

  public prevQuestion() {
    let len = this.samilerQuestions.length
    if (len) {
      this.currentIndex -= 1
    }
    setTimeout(() => {
      sa.track('ContentRepository_question_Other', {
        screenType: '预览页面',
        buttonName: '上一题'
      })
    }, 50)
  }

  public nextQuestion() {
    let len = this.samilerQuestions.length
    if (len) {
      this.currentIndex += 1
    }
    setTimeout(() => {
      sa.track('ContentRepository_question_Other', {
        screenType: '预览页面',
        buttonName: '下一题'
      })
    }, 50)
  }
}
